<template>
  <a :rel="rel" :target="target" :href="href" @click="onClick($event)" :class="format">
    <div class="row no-gutters">
      <div class="col-2 icons" v-if="icon">
        <FileAlt v-if="icon === 'file-alt'" />
      </div>
      <div class="col-8" :class="[ icon? 'col-8':'col-10' ]">
        <span>
          <slot />
        </span>
        <span class="source" v-if="source">
          <span>{{date}}</span>
          - {{source}}
        </span>
      </div>
      <div class="col-2 icons end">
        <ExternalLink class="ext-link" />
      </div>
    </div>
  </a>
</template>

<script>
import FileAlt from '../../assets/icons/file-alt.svg';
import ExternalLink from '../../assets/icons/external-link.svg';

export default {
  name: 'LinkButton',
  components: {
    FileAlt,
    ExternalLink,
  },
  props: {
    href: {
      type: String,
      default: '#',
    },
    preventDefault: Boolean,
    target: {
      type: String,
      default: '_self',
    },
    rel: {
      type: String,
      default: 'noopener',
    },
    format: {
      type: String,
      default: 'document', // Document - Press
    },
    icon: {
      type: String,
      default: 'file-alt',
    },
    source: String,
    date: String,
  },
  methods: {
    onClick($event) {
      if (this.preventDefault) $event.preventDefault();
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
a {
  display: block;
  width: 100%;

  svg {
    &.ext-link {
      float: right;
    }
  }

  span {
    margin-top: 7px;
    display: block;
    line-height: 1.3;

    &.source {
      font-size: 10px;
      color: #979797;
      font-family: "Montserrat", sans-serif;
      span {
        display: inline;
        font-weight: 600;
      }
    }
  }
}
a {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #000000;
  text-decoration: none;
  line-height: 1;
  word-break: break-word;

  &.document {
    font-size: 12px;
    padding-left: 5px;
    padding-right: 5px;
    color: #000000;
    border-bottom: 1px solid #e5e5e5;
  }

  &.press {
    color: #000000;
    font-size: 14px;

    &:hover {
      text-decoration: none;
    }
  }

  .icons {
    display: flex;
    &.end {
      justify-content: flex-end;
    }

    svg {
      align-self: center;
    }
  }
}
</style>
